import { DataPlanType } from 'my-account/constants';
import { ChildModel, ModelBase } from 'store/model-base';
import { StatementDataPlan } from './plan';

export class StatementDataDetails extends ModelBase {
    public static storeName: string = 'statementDataDetails';

    public totalDataCost: number;
    public totalDataUsage: number;
    public planGroups: StatementDataPlan[];
    public totalUnlimitedDataCost: number;
    public hasUnlimitedPlans: boolean;
    public hasByTheGigPlans: boolean;
    public hasWatchData: boolean;
    public hasTabletData: boolean;
    public servicePromotionTotal: number;
    public planPriceAfterServicePromo: number;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.planGroups = data.planGroups && data.planGroups.filter((planGroup: StatementDataPlan) => Boolean(planGroup.planType)) || [];
        data.hasUnlimitedPlans = Boolean(data.planGroups.find((planGroup: StatementDataPlan) => planGroup.planType === DataPlanType.UNLIMITED));
        data.hasByTheGigPlans = Boolean(data.planGroups.find((planGroup: StatementDataPlan) => planGroup.planType === DataPlanType.BY_THE_GIG_SHARED || planGroup.planType === DataPlanType.BY_THE_GIG));
        data.hasWatchData = Boolean(data.planGroups.find((planGroup: StatementDataPlan) => planGroup.planType === DataPlanType.SMART_WATCH));
        data.hasTabletData = Boolean(data.planGroups.find((planGroup: StatementDataPlan) => planGroup.planType === DataPlanType.TABLET));

        return super.create<T>(data);
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'planGroups',
            model: StatementDataPlan
        }];
    }

    public get unlimitedPlanGroup(): StatementDataPlan[] {
        return this.planGroups.filter((planGroup: StatementDataPlan) => planGroup.planType === DataPlanType.UNLIMITED);
    }

    public get byTheGigPlan(): StatementDataPlan {
        return this.planGroups.find((planGroup: StatementDataPlan) => planGroup.planType === DataPlanType.BY_THE_GIG_SHARED || planGroup.planType === DataPlanType.BY_THE_GIG);
    }

    public get byTheGigPlanGroup(): StatementDataPlan[] {
        return this.planGroups.filter((planGroup: StatementDataPlan) => planGroup.planType === DataPlanType.BY_THE_GIG_SHARED || planGroup.planType === DataPlanType.BY_THE_GIG);
    }

    public get watchDataPlan(): StatementDataPlan {
        return this.planGroups.find((planGroup: StatementDataPlan) => planGroup.planType === DataPlanType.SMART_WATCH);
    }

    public get tabletDataPlan(): StatementDataPlan {
        return this.planGroups.find((planGroup: StatementDataPlan) => planGroup.planType === DataPlanType.TABLET);
    }

    public get unlimitedLineCount(): number {
        let lineCount: number = 0;
        this.unlimitedPlanGroup.forEach((unlimitedPlanGroup: StatementDataPlan) => {
            lineCount = lineCount + unlimitedPlanGroup.lineCount;
        });

        return lineCount;
    }

    public get byTheGigLineCount(): number {
        let lineCount: number = 0;
        this.byTheGigPlanGroup?.forEach((planGroup: StatementDataPlan) => {
            lineCount += planGroup.lineCount;

        });

        return lineCount;
    }
}
